<h2 class="pb-s">
  Aktionen
</h2>
<p>
  Wir unterstützen Sie nicht nur mit wertvollen Tipps & Tricks für Ihren gelungenen Arbeitsalltag sondern geben Ihnen mindestens zweimal jährlich mit unseren Aktionen eine zusätzliche Portion Humor und Spaß zur optimalen Work-Fun-Balance mit auf den Weg. Schauen Sie sich unsere letzten Aktionen an und freuen Sie sich auf spannende Teilnahmemöglichkeiten mit großartigen Gewinnspielen für Sie und das ganze Team!
</p>

<img src="../../assets/dummy/Aktionen1.jpg" alt="PKP Aktionen" class="my-s">
<img src="../../assets/dummy/Aktionen2.jpg" alt="PKP Aktionen" class="my-s">

<p class="mt-l">
  Sie nehmen noch nicht an unserem Beauftragtenprogramm teil, wollen die kommende Aktion aber auf keinen Fall verpassen? Dann melden Sie sich jetzt direkt an.
</p>

<a href="/#/page/anmeldung" class="btn btn-cms">Anmelden</a>
